import React, { FunctionComponent } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../Page.css";
import Grids from "../../Component/Grides";
import { useAppDispatch, useAppSelector } from "../../Redux/store/hooks";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { Alert, Button, LinearProgress, Snackbar } from "@mui/material";
import Dialogs from "../../Component/Dialog";
import { false_switchDeleteMepvalues } from "../../Redux/Reducers/Datagrid-values/DeleteMap-values-slicer";
import MarketholidayMessage from "./MarketholidayMessage";
import DialogMarketHoliday from "../../Component/DialogForFormMarketholiday";
import { list_MarketholidayList } from "../../Redux/Reducers/Marketholiday/list_Marketholiday_slicer";
import {
  delete_DeleteMarketholiday,
  false_switchDeleteMarketholiday_response,
} from "../../Redux/Reducers/Marketholiday/delete_Marketholiday_slicer";
import { false_switchDeleteHolidayvalues } from "../../Redux/Reducers/Datagrid-values/DeleteHoliday-values-slicer";
import {
  add_AddMarketholiday,
  false_switchAddMarketholiday_response,
} from "../../Redux/Reducers/Marketholiday/add_Marketholiday_slicer";
import Warning from "../svg_image/Waring.gif";

interface MarketHolidayProps {}

const MarketHoliday: FunctionComponent<MarketHolidayProps> = () => {
  const dispatcher = useAppDispatch();

  const breadcrumbs = [
    <Link
      key="1"
      color="black"
      underline="none"
      sx={{
        fontSize: {
          xs: "20px",
          sm: "20px",
          md: "20px",
          lg: "20px",
          xl: "24px",
        },
      }}
    >
      <span style={{ fontFamily: "Roboto" }}>General Configuration</span>
    </Link>,
    <Link
      underline="none"
      key="1"
      color="inherit"
      href="/viewadmin"
      sx={{
        fontWeight: "500",
        fontSize: {
          xs: "20px",
          sm: "20px",
          md: "20px",
          lg: "20px",
          xl: "24px",
        },
        color: "#BDBDBD",
      }}
    >
      <span style={{ fontFamily: "Roboto" }}>Market Holiday</span>
    </Link>,
  ];

  const data = useAppSelector((state) => state?.MarketholidayList?.data);
  const addData: any = useAppSelector((state) => state?.AddMarketholiday?.data);
  const addDataIsLoading = useAppSelector(
    (state) => state?.AddMarketholiday?.isLoading
  );
  const deleteData: any = useAppSelector(
    (state) => state?.DeleteMarketholiday?.data
  );
  const DeleteisLoading: any = useAppSelector(
    (state) => state?.DeleteMarketholiday?.isLoading
  );
  const isLoadingdata = useAppSelector(
    (state) => state?.MarketholidayList?.isLoading
  );
  const AddResponse = useAppSelector(
    (state) => state.AddMapStrategies.switchResponse
  );
  const switchResponsealgodelete = useAppSelector(
    (state) => state.DeleteMarketholiday.switchResponse
  );
  const Uservaluesalgodelete: any = useAppSelector(
    (state) => state.DeleteHolidayvalues.data
  );
  const switchOpenalgodelete = useAppSelector(
    (state) => state.DeleteHolidayvalues.switch
  );

  const column = [
    {
      sortable: true,
      headerName: (
        <p
          className="headingnamebold"
          style={{ color: "white", fontWeight: "bolder" }}
        >
          Date
        </p>
      ),
      flex: 1,
      field: "holiday_date",
      valueGetter: (params: any) => {
        return params.row.holiday_date;
      },
      renderCell: (params: GridRenderCellParams<any>) => {
        // Access the "name" property from the "algo" object

        const originalDate = params.row.holiday_date; // Date in "YYYY-MM-DD" format
        const [year, month, day] = originalDate.split("-");
        const formattedDate = `${day}-${month}-${year}`; // Rearranging date parts

        return <div title={formattedDate}>{formattedDate}</div>;
      },
    },
    {
      headerName: (
        <p
          className="headingnamebold"
          style={{ color: "white", fontWeight: "bolder" }}
        >
          Segment
        </p>
      ),
      sortable: true,
      valueGetter: (params: any) => {
        return params.row.segment.map((strategy: any) => strategy);
      },
      field: "segment", // Assuming "strategy" is the property in your data
      renderCell: (params: GridRenderCellParams<any>) => {
        // Access the "name" property from the "strategy" object
        const strategyNames = params.row.segment.map((strategy: any) => {
          return `${strategy} |  `;
        });

        return (
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            title={strategyNames}
          >
            {strategyNames}
          </div>
        );
      },
      flex: 1,
    },

    true
      ? {
          headerName: (
            <p
              className="headingnamebold"
              style={{ color: "white", fontWeight: "bolder" }}
            >
              Action
            </p>
          ),
          field: "Action",
          flex: 1,
          type: "actions",
          renderCell: (params: any) => {
            return (
              <MarketholidayMessage
                valuepopup={params.row.id}
              ></MarketholidayMessage>
            );
          },
        }
      : {
          flex: 1,
          type: "actions",
          hide: true,
          display: false,
          renderCell: (params: any) => {
            return null;
          },
        },
  ];

  React.useEffect(() => {
    dispatcher(list_MarketholidayList(""));

    if (switchResponsealgodelete) {
      dispatcher(false_switchDeleteMepvalues());
    }
  }, [addData, deleteData, dispatcher, switchResponsealgodelete]);

  const actions = (
    <button
      onClick={() => {
        dispatcher(false_switchDeleteMarketholiday_response()); // Close the Snackbar immediately
      }}
      style={{
        color: "white",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
      }}
    >
      Close
    </button>
  );
  const Addaction = (
    <button
      onClick={() => {
        dispatcher(false_switchAddMarketholiday_response()); // Close the Snackbar immediately
      }}
      style={{
        color: "white",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
      }}
    >
      Close
    </button>
  );
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={AddResponse} // Use alertOpen to control the Snackbar's visibility
        autoHideDuration={6000} // Set the desired auto-hide duration (in milliseconds)
        onClose={() => dispatcher(false_switchAddMarketholiday_response())}
        key={`top-right`}
        action={Addaction}
      >
        <Alert
          onClose={() => dispatcher(false_switchAddMarketholiday_response())}
          severity="success"
        >
          {/* {props?.successMessage?.message} */}
          {addData.message}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={switchResponsealgodelete} // Use alertOpen to control the Snackbar's visibility
        autoHideDuration={6000} // Set the desired auto-hide duration (in milliseconds)
        onClose={() => dispatcher(false_switchDeleteMarketholiday_response())}
        key={`top-right`}
        action={actions}
      >
        <Alert
          onClose={() => dispatcher(false_switchDeleteMarketholiday_response())}
          severity="success"
        >
          {/* {props?.successMessage?.message} */}
          {deleteData.message}
        </Alert>
      </Snackbar>
      <LinearProgress
        style={{
          color: "black",
          width: "100%",
          marginTop: "-15px",
          display:
            isLoadingdata || addDataIsLoading || DeleteisLoading
              ? "block"
              : "none",
        }}
      />
      <Stack
        spacing={10}
        className="breadcrumbs"
        sx={{ margin: "0px 20px 20px 20px " }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
      <Grids
        row={data}
        column={column}
        gridesbutton
        pagination
        dialog={
          <DialogMarketHoliday
            successMessage={addData}
            isLoading={addDataIsLoading}
            sx={{
              padding: "15px",
              background: "linear-gradient(to right, #FFFA02,#F2A618 )",
              color: "black",
              width: {
                xs: 60,
                sm: 100,
                md: 100,
                lg: 100,
                xl: 150,
              },
              height: "37px",
              borderRadius: "5px",
              fontFamily: "Roboto",
              textTransform: "capitalize",
              marginLeft: "10px",
              "&:hover": { backgroundColor: "#EF990F" },
            }}
            getValues={(v: any) => {
              dispatcher(add_AddMarketholiday(v));
            }}
            Buttondialog={["Cancel"]}
            Dialogtitle={"Add Market Holiday"}
            Buttonname={"Add New"}
          />
        }
        Userpermissions={undefined}
      ></Grids>

      <Dialogs
        maxWidth={"xs"}
        subtitle={"Warning"}
        Dialog_Title={<img src={Warning} alt="Success..." height="100px" />}
        open={switchOpenalgodelete}
        setOpen={() => dispatcher(false_switchDeleteMepvalues())}
        Dialog_Content={"Are you sure you want to delete?"}
        Dialog_Actions={
          <>
            <Button
              sx={{
                padding: "15px",
                color: "#F4A717",
                width: "100px",
                height: "37px",
                borderRadius: "5px",
                textTransform: "capitalize",
                border: "1px solid #F4A717",
                backgroundColor: "white",
                "&:hover": { backgroundColor: "white" },
              }}
              onClick={() => dispatcher(false_switchDeleteHolidayvalues())}
            >
              No
            </Button>
            <Button
              style={{
                color: "white",
                width: "100px",
                height: "37px",
                borderRadius: "5px",
                textTransform: "capitalize",
                marginLeft: "20px",
              }}
              autoFocus
              sx={{
                background: "#F4A717",
                "&:hover": {
                  background: "#F4A717",
                },
              }}
              onClick={() => {
                dispatcher(delete_DeleteMarketholiday(Uservaluesalgodelete));
                dispatcher(false_switchDeleteHolidayvalues());
              }}
            >
              yes
            </Button>
          </>
        }
      />
    </div>
  );
};

export default MarketHoliday;
